import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { vmPropTypes } from '../../global-prop-types';
import ComponentsArrRenderer from '../core/ComponentsArrRenderer';
import { useDispatchVmEventList } from '../../global-utils';
import vmFunctions from '../../global-utils/vmFunctions';
import useShallowEqualSelector from '../core/useShallowEqualSelector';

const EventDispatcherOnUnmount = (props) => {
  const dispatchVmEventList = useDispatchVmEventList();
  const store = useShallowEqualSelector((state) => state);
  const { vmEventList, ...restProps } = props;
  const dataBank = { vmFunctions, props, store };

  // dispatch once:
  useEffect(() => () => {
    dispatchVmEventList(vmEventList, dataBank);
  }, []);

  return <ComponentsArrRenderer {...restProps} />;
};

EventDispatcherOnUnmount.propTypes = {
  vmEventList: PropTypes.array,
};

EventDispatcherOnUnmount.vmPropTypes = {
  vmEventList: vmPropTypes.array,
  components: vmPropTypes.components
};

export default EventDispatcherOnUnmount;
